import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { RoutesConstants } from "@/main/routes/routesConstants";
import Button from "@/main/components/shared/button/button";
import { getTranslateByKey } from "@/main/services/utils";
import { useStyles } from "./styles";

interface Props {
	styles?: any;
}

export default function NoAccessPermissionScreen({ styles }: Props) {
	const classes = useStyles();
	const navigate = useNavigate();

	return (
		<Box
			display="flex"
			justifyContent="center"
			flexDirection="column"
			padding="5px"
			alignItems="center"
			style={styles || {}}
		>
			<div className={classes.iconPermission} />
			<span className={classes.messageResultFound}>{getTranslateByKey("information.noPermission", true)}</span>
			<Button style={{ marginTop: 30, marginLeft: 0 }} onClick={() => navigate(RoutesConstants.home)}>
				{getTranslateByKey("information.backToHome")}
			</Button>
		</Box>
	);
}
